<template>
  <div class="ele-wrap">
    <div class="content" style="
         {
          width: 100%;
        }
      ">
      <div class="search-box box">
        <time-search ref="timeSearch" :control="{ data: timeData }" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick">
        </time-search>
      </div>
      <div class="grid-content item-box">
        <div class="details-content">
          <div class="byTitle" id="warpId" ref="datas">
            <el-tag style="margin-bottom: 7px" :title="item.name" v-for="(item, index) in dynamicTags" :key="index" closable :disable-transitions="false" @close="handleClose(index)">
              {{ item.omitName }}
            </el-tag>
            <el-button style="height: 30px; line-height: 0px; margin-left: 10px" type="primary" @click="addMeasure">添加计量点</el-button>
          </div>
          <div class="item-box chart-box box">
            <echart-line ref="analysisChart" :lineData="lineData" :searchType="searchType" :loading="loading"></echart-line>
          </div>
        </div>
      </div>
      <!-- 选择计量点开始 -->
      <el-dialog title="选择计量点" :visible.sync="showMeasure" width="700px" :close-on-click-modal="false">
        <div style="
            padding: 6px;
            background: #409eff;
            color: #fff;
            text-align: left;
          ">
          视图列表：
          <el-select style="width: 140px" size="mini" v-model="objId">
            <el-option v-for="(item, index) in viewData" :key="index" :value="item.id" :label="item.displayName"></el-option>
          </el-select>
        </div>
        <div class="tree-con">
          <!-- show-checkbox -->
          <!-- @node-click="leftTreeClick" -->
          <el-tree :data="treeData" node-key="id" ref="tree" :check-strictly="true" show-checkbox @check-change="checkTree" default-expand-all :highlight-current="true" :expand-on-click-node="false" class="treeBox">
            <span class="custom-tree-node" slot-scope="{ data }">
              <span class="node-label">{{ data.measureName }}</span>
            </span>
          </el-tree>
          <el-button style="height: 30px; line-height: 0px; margin-left: 20px" type="primary" @click="addView">添加</el-button>
        </div>
        <div class="topstyle" style="margin: 10px 7px">
          <label style="display: flex; align-items: center">数据项</label>
          <el-select style="width: 200px; margin-left: 10px" v-model="tabType" @change="changeTab($event)">
            <el-option v-for="(item, index) in tabData" :key="index" :label="item.label" :value="item.label">
            </el-option>
          </el-select>
        </div>
        <div class="topstyle">计量点集合:</div>
        <div class="topstyle1">
          <el-tag style="margin-bottom: 7px" v-for="(item, index) in dynamicTagsNew" :key="index" closable :disable-transitions="false" @close="handleCloseNew(index)">
            {{ item.measureName }}
          </el-tag>
        </div>
        <span slot="footer" class="dialog-footer" style="margin-right: 250px">
          <el-button @click="showMeasure = false">取 消</el-button>
          <el-button type="primary" @click="saveMeasure">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 选择计量点结束 -->
    </div>
  </div>
</template>
<script>
import tree from "@/utils/tree";
import * as fpg from "@/utils/fpg.js";
import echartLine from "./page/echartLine.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import api from "@common/api/index.js";
import { findDataByParam } from "@/utils/index.js";
import handleData from "@/utils/handleData.js";
import dateTool from "@/utils/dateTool";
import elementResizeDetectorMaker from "element-resize-detector";
import uuidv1 from "uuid/v1";
let allTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "week",
    label: "周",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "timeInterval",
    label: "时段",
  },
];
let eleTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
export default {
  name: "ele",
  // 引用组件
  components: {
    echartLine,
    TimeSearch,
  },
  data () {
    return {
      timeData: allTimeData,
      warpId: uuidv1(),
      dateType: null,
      loading: false,
      tabData: [
        {
          label: "正向有功总电能",
          value: "positiveActiveEle",
          type: "正向有功总电能",
          code: "100229",
        },
        {
          label: "反向有功总电能",
          value: "reverseActiveEle",
          type: "反向有功总电能",
          code: "100230",
        },
        {
          label: "正向无功总电能",
          value: "positiveReactiveEle",
          type: "反向有功总电能",
          code: "100231",
        },
        {
          label: "反向无功总电能",
          value: "reverseReactiveEle",
          type: "反向有功总电能",
          code: "100232",
        },
        { label: "负荷率", value: "LOAD_RATE", type: "负荷率", code: "233" },
        {
          label: "平均总功率因数",
          value: "TOTAL_POWER_FACTOR_AVG",
          type: "平均总功率因数",
          code: "252",
        },
        {
          label: "平均负载率",
          value: "LOAD_FACTOR_AVG",
          type: "平均负载率",
          code: "253",
        },
        {
          label: "正向流量",
          value: "forwardFlow",
          type: "正向流量",
          code: "100401",
          legend: "正向流量",
        },
        {
          label: "反向流量",
          value: "reverseFlow",
          type: "反向流量",
          code: "100402",
          legend: "反向流量",
        },
        {
          label: "计数",
          value: "COUNT_QUANTITY",
          type: "计数",
          code: "100701",
          legend: "计数",
        },
        {
          label: "能源消耗量",
          value: "ENERGY_CONSUMPTION",
          type: "能源消耗量",
          code: "100801",
          legend: "能源消耗量",
        },
        {
          label: "用户自定义",
          value: "USER_CUSTOM_COUNT",
          type: "用户自定义",
          code: "1000",
          legend: "用户自定义",
        },
      ],
      searchType: "hour",
      tabShow: true,
      selectedTab: "",
      selectedDate: {
        startTime: "",
        endTime: "",
      },
      //运行状态
      tabType: "正向有功总电能",
      tabSelect: {},
      dynamicTags: [],
      dynamicTagsNew: [],
      showMeasure: false,
      viewData: [],
      objId: null,
      treeData: [],
      lineData: {},
      treeSelect: {},
      itemCode: "100229", //选中数据项的code
      measureName: "",
      treeDataNew: [],
      putTree: [],
    };
  },
  // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  beforeCreate () { },
  // 实例已经创建完成之后被调用。
  created () {
    let vm = this;
    vm.tabSelect = vm.tabData[0];
    let time = new Date();
    let startTime = dateTool.format(time, "yyyy-MM-dd ") + "00:00:00";
    time.setDate(time.getDate() + 1);
    let endTime = dateTool.format(time, "yyyy-MM-dd") + " 00:00:00";
    vm.selectedDate = {
      dataType: "1",
      dateType: "day",
      endTime: endTime,
      startTime: startTime,
    };
    vm.TimeControlClick(vm.selectedDate);
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () {
    let vm = this;
    vm.$eventBus.$on("changeCompanyId", (companyId) => {
      vm.init();
    });
  },
  // keep-alive组件激活时调用
  activated () { },
  // 数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子
  updated () { },
  //当前路由改变
  beforeRouteUpdate () { },
  // Vue 实例销毁后调用
  destroyed () { },
  // 计算属性
  computed: {},
  // 数据监听
  watch: {
    selectedTab (val, oldVal) {
      this.updateData(val, oldVal);
    },
    objId (val) {
      let vm = this;
      vm.getViewTreeNodes(val);
    },
    tabType (val) {
      let vm = this;
      //   vm.isShowSearchType()
    },
    searchType (val) { },
  },
  // 方法定义
  methods: {
    timeControlChange (e) {
      this.selectedDate = e;
      //   this.isShowSearchType()
    },
    //查询
    TimeControlClick (e) {
      let vm = this;
      this.selectedDate = e;
      vm.getData();
    },
    //切换数据项
    changeTab (row, code) {
      this.tabSelect = this.tabData.find((obj) => {
        return obj.label == row;
      });
      this.itemCode = this.tabSelect.code;
    },
    //获取数据
    getData () {
      let vm = this;
      vm.loading = true;
      vm.dateType = vm.selectedDate.dateType;
      let pointNumber = "0";
      let num = vm.tabSelect.pointNumber ? vm.tabSelect.pointNumber : "0";
      let startTime = vm.selectedDate.startTime;
      let endTime = vm.selectedDate.endTime;
      //生成measures
      let lineData = {
        xData: [],
        series: [],
        legend: [],
      };
      if (vm.dynamicTags.length == 0) {
        vm.loading = false;
        vm.lineData = {
          xData: [],
          series: [],
          legend: [],
        };
      }
      vm.dynamicTags.forEach((item, i) => {
        let measures = [];
        lineData.series[i] = {
          data: [],
          type: "line",
          name: item.omitName,
        };
        lineData.legend[i] = item.omitName;
        item.id.map((obj, i) => {
          measures.push({
            measureId: obj,
            pointNumber: num,
            pointCode: item.code[i],
          });
        });
        if (vm.searchType == "hour") {
          vm.$api.quantity
            .getQuantityHour2(measures, startTime, endTime, 0)
            .then((resArr) => {
              if (!resArr.success) {
                vm.$message.error(resArr.msg);
                return;
              }
              let echartsData = vm.merge(resArr.data);
              lineData.xData = fpg.getXdata(
                vm.selectedDate.startTime,
                vm.selectedDate.endTime,
                vm.selectedDate.dateType
              ); //获取柱状图x轴
              let timeData = JSON.parse(
                JSON.stringify(
                  fpg.getMatchTimeData(
                    vm.selectedDate.startTime,
                    vm.selectedDate.endTime,
                    "0"
                  )
                )
              ); //匹配查询时间 [{00:}]
              lineData.series[i].data = [];
              timeData.forEach((item) => {
                echartsData.forEach((obj) => {
                  if (obj.time.substring(0, 13) == item.time.substring(0, 13)) {
                    item.value = obj.value === "" ? "-" : obj.value.toFixed(2);
                  }
                });
                lineData.series[i].data.push(item.value);
              });
              vm.lineData = JSON.parse(JSON.stringify(lineData));
              vm.loading = false;
            });
        }
      });
    },
    //将相同计量点数据合并
    merge (resArr) {
      let res = [];
      let newArr = [];
      //思路  先将所有的数组整合到一个新数组，然后把相同time的数据放进一个新数组，然后再把相同time的value相加并去重
      resArr.forEach((item, key) => {
        item.data.forEach((obj) => {
          newArr.push(obj);
        });
      });
      return this.deteleObject(newArr);
    },
    //将相同的time相加并去重
    deteleObject (res) {
      var newArr = [];
      res.forEach((item) => {
        var dataItem = item;
        if (newArr.length > 0) {
          var filterValue = newArr.filter((v) => {
            return v.time.substring(0, 13) == dataItem.time.substring(0, 13);
          });
          if (filterValue.length > 0) {
            newArr.forEach((n) => {
              if (
                n.time.substring(0, 13) == filterValue[0].time.substring(0, 13)
              ) {
                n.value = filterValue[0].value + dataItem.value;
              }
            });
          } else {
            newArr.push(dataItem);
          }
        } else {
          newArr.push(dataItem);
        }
      });
      return newArr;
    },
    //数据项集合关闭
    handleClose (index) {
      this.dynamicTags.splice(index, 1);
    },
    //数据项集合关闭
    handleCloseNew (index) {
      this.dynamicTagsNew.splice(index, 1);
      this.TimeControlClick(this.selectedDate);
    },
    //添加计量点
    addMeasure () {
      let vm = this;
      vm.showMeasure = true;
      (vm.tabType = "正向有功总电能"), vm.getCompanyViewTreesInfo();
      vm.dynamicTagsNew = [];
      this.putTree = [];
      this.$refs.tree.setCheckedKeys([]);
      //   vm.treeSelect = {}
    },
    //加载视图列表数据
    getCompanyViewTreesInfo () {
      let vm = this;
      api.view
        .getCompanyViewTreesInfo(this.$store.state.user.currentCompanyId)
        .then((res) => {
          if (res) {
            vm.viewData = res.data;
            if (res.data.length > 0) {
              vm.objId = res.data[0].id;
            }
          }
        });
    },
    //视图树点击
    // leftTreeClick(data) {
    //   let vm = this
    //     vm.treeSelect =JSON.parse(JSON.stringify(data));
    //   this.measureName=data.measureName
    // },
    //视图树勾选事件
    checkTree (data, ifCheck, childCheck) {
      let vm = this;
      if (ifCheck) {
        vm.putTree.push(data);
      } else {
        let itemInedex = vm.putTree.findIndex((obj) => obj.id == data.id);
        if (itemInedex > -1) {
          vm.putTree.splice(itemInedex, 1);
        }
      }
    },
    //添加视图
    addView () {
      let vm = this;
      vm.dynamicTagsNew = [];
      vm.putTree.forEach((temp, i) => {
        let item = vm.dynamicTagsNew.find((obj) => {
          return obj.id == temp.id && obj.code == this.itemCode;
        });
        if (!item) {
          let temp1 = JSON.parse(JSON.stringify(temp));
          this.measureName = temp1.measureName;
          temp1.measureName = JSON.parse(
            JSON.stringify(this.measureName + "(" + vm.tabType + ")")
          );
          vm.dynamicTagsNew.push(Object.assign({ code: this.itemCode }, temp1));
        }
      });
    },
    //获取视图数据
    getViewTreeNodes (id) {
      api.view.getViewTreeNodes(id).then((res) => {
        let data = tree.creatTreeJson(res.data, 0);
        this.treeData = data;
        this.putTree = [];
        this.treeDataNew = res.data;
      });
    },
    //选择计量点
    saveMeasure () {
      let vm = this;
      if (vm.dynamicTagsNew.length == 0) {
        vm.$message({
          type: "warning",
          message: "请先添加视图点",
        });
        return;
      } else {
        let obj = { name: "", id: [], code: [] };
        vm.dynamicTagsNew.map((item) => {
          obj.name += "+" + item.measureName;
          obj.id.push(item.measureId);
          obj.code.push(item.code);
        });
        obj.name = obj.name.substr(1);
        if (obj.name.length < 20) {
          obj.omitName = obj.name;
        } else {
          obj.omitName = obj.name.slice(0, 20) + "...";
        }

        vm.dynamicTags.push(obj);
      }
      vm.TimeControlClick(vm.selectedDate);
      vm.showMeasure = false;
    },
  },
};
</script>
<style scoped>
.treeBox >>> .el-tree-node {
  min-height: 26px;
}
</style>
<style lang="scss">
.time-search-slot {
  .el-input__inner,
  .el-input__icon {
    height: 30px;
    line-height: 30px;
  }
}
</style>
<style lang="scss" scoped>
.ele-wrap {
  height: 100%;
  padding: 14px;
  display: flex;
  box-sizing: border-box;
}
.content {
  width: 100%;
}
.grid-content {
  position: relative;
  height: calc(100% - 50px);
}
.details-content {
  width: 100%;
  height: 100%;
}
.table-content {
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}
.table-layout {
  width: calc(100% + 20px);
  height: 340px;
  margin: -10px -10px -10px -10px;
}
.table-layout td {
  width: 25%;
}
.table-layout tr {
  height: 100%;
}
.item-box {
  width: 100%;
  text-align: left;
  margin-top: 14px;
}
.tab-box {
  height: 30px;
}
.chart-box {
  background: none;
  //   height: calc(100% - 64px);
  height: 93%;
  margin-bottom: 14px;
}
.search-box {
  height: 36px;
}
.table-box {
  // padding-bottom: 20px;
}
.homocycle-ratio-box {
  width: 100%;
  height: 120px;
  padding: 10px;
  box-sizing: border-box;
}
.byTitle {
  //   height: 50px;
  //   line-height: 50px;
  background: #fff;
  border-radius: 4px;
  color: #fff;
  padding: 7px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.custom-tree-node {
  width: 100%;
  padding-right: 20px;
  display: flex;
  align-items: center;
}
.custom-tree-node .node-label {
  flex: 1;
  text-align: left;
}
.custom-tree-node .node-btn {
  padding: 0px 6px;
}
.tree-con {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.treeBox {
  display: flex;
  flex-flow: column;
  flex: 3;
  height: 250px;
  overflow: auto;
}
.topstyle {
  text-align: left;
  margin: 7px;
  display: flex;
  flex-wrap: wrap;
}
.topstyle1 {
  text-align: left;
  margin: 7px;
  display: flex;
  flex-wrap: wrap;
  max-height: 150px;
  overflow: auto;
}
</style>